// extracted by mini-css-extract-plugin
export default {"searchBtn":"Search_searchBtn__5y2DK","searchClearBtn":"Search_searchClearBtn__iSKU0"};